export default __webpack_public_path__ + "static/media/curso_avanzado_cover.64bfabca.png";